// Project data - Single source of truth for all portfolio projects
export const projects = [
  // ── 2026 ──────────────────────────────────────────────────────────────────
  {
    id: 30,
    title: "JXT Watch",
    description:
      "A movie streaming platform similar to Netflix, delivering seamless video playback with zero buffering. Fully hosted on Cloudflare for optimal performance.",
    longDescription: `
      JXT Watch is a movie streaming platform built to provide a Netflix-like experience with superior performance. The entire platform is hosted on Cloudflare, leveraging their global edge network to ensure lightning-fast video delivery with absolutely no buffering.

      Key features:
      • Netflix-style movie streaming interface
      • Zero buffering through Cloudflare's global edge network
      • High-quality video playback optimized for all devices
      • Seamless user experience with instant loading
      • Movie browsing, search, and categorization
      • Responsive design for mobile, tablet, and desktop
      • Cloudflare-powered hosting for maximum speed and reliability
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://jxtwatch.online",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://jxtwatch.online"],
    technologies: ["React", "Cloudflare", "Cloudflare Workers", "Cloudflare Pages", "Cloudflare R2", "Video Streaming"],
    category: "web",
    githubUrl: null,
    liveUrl: "https://jxtwatch.online",
    featured: true,
    status: "completed",
    completedDate: "2026-10-30",
    duration: "2 months",
    teamSize: "1",
    priority: -1,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Movie Streaming", "Netflix-like", "Cloudflare", "Zero Buffering", "Video Platform"],
    challenges: [
      "Achieving zero buffering for video streaming across all regions.",
      "Building a Netflix-like UI with smooth transitions and intuitive navigation.",
    ],
    solutions: [
      "Leveraged Cloudflare's global edge network and R2 storage for instant video delivery.",
      "Designed a sleek, Netflix-inspired interface with React and smooth animations.",
    ],
  },
  {
    id: 29,
    title: "Putduck Client Console",
    description:
      "Integrated the Putduck platform into a client console — a mobile app delivering a seamless client-facing dashboard experience.",
    longDescription: `
      Putduck Client Console is a mobile application built for a client, integrating the Putduck platform directly into a custom client console. The app provides a smooth, intuitive mobile experience for managing and interacting with the client's platform from anywhere.

      Key features:
      • Full Putduck platform integration within a mobile interface
      • Client console dashboard for real-time management
      • Clean, responsive mobile UI tailored to the client's brand
      • Secure authentication and role-based access
      • Cross-platform support for iOS and Android
    `,
    image: null,
    images: [],
    technologies: ["React Native", "Expo", "JavaScript", "REST API"],
    category: "mobile",
    githubUrl: null,
    liveUrl: null,
    featured: false,
    status: "completed",
    completedDate: "2026-08-27",
    duration: null,
    teamSize: "1",
    priority: 1,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Mobile App", "Client Project", "Putduck Integration", "Console Dashboard"],
    challenges: [
      "Integrating an existing platform API into a mobile-first interface.",
      "Designing an intuitive console dashboard for mobile screens.",
    ],
    solutions: [
      "Built a clean React Native interface that mirrors the Putduck console experience on mobile.",
      "Designed compact dashboard components optimised for small screens.",
    ],
  },
  {
    id: 27,
    title: "A.M.A",
    description:
      "An anonymous messaging platform with enhanced privacy features and 100% anonymity. A better alternative to NGL.",
    longDescription: `
      A.M.A is a mobile application that revolutionizes anonymous messaging with a focus on complete user privacy. Unlike other platforms like NGL, A.M.A ensures 100% anonymity with enhanced security features.

      Key features:
      • 100% Anonymous messaging
      • Enhanced privacy controls
      • No data tracking or storage
      • Clean and intuitive UI
      • Real-time message delivery
      • Cross-platform compatibility
      • Advanced security measures
      • Multiple question types and formats
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://askmeanything-amp.pages.dev/",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://askmeanything-amp.pages.dev/"],
    technologies: ["React Native", "Python", "PostgreSQL", "Expo"],
    category: "mobile",
    githubUrl: null,
    liveUrl: "https://askmeanything-amp.pages.dev/",
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "3 months",
    teamSize: "1",
    priority: 0,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["100% Anonymous", "Privacy-First", "Real-Time Messaging", "Mobile App"],
    challenges: [
      "Ensuring complete user anonymity.",
      "Building secure real-time messaging.",
      "Creating intuitive mobile UX.",
    ],
    solutions: [
      "Architected a zero-knowledge messaging flow with no user data stored.",
      "Used secure WebSocket connections for real-time delivery.",
      "Designed a minimal, distraction-free mobile interface with Expo.",
    ],
  },
  {
    id: 25,
    title: "TboyeMedia",
    description: "A full-service digital media platform delivering content, creative solutions, and media services for brands and individuals.",
    longDescription: `
      TboyeMedia is a full-service digital media platform built to deliver high-quality content creation, branding, and media services. It connects brands and individuals with professional media solutions — from visual content to digital strategy.

      Key features:
      • Digital content creation and management
      • Brand identity and media strategy services
      • Portfolio showcase for media work
      • Client-facing service listings and packages
      • Contact and inquiry system
      • Responsive, modern design
      • SEO-optimized for discoverability
      • Fast, lightweight frontend
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://tboyemedia.com/",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://tboyemedia.com/"],
    technologies: ["React", "Netlify", "Cloudflare Workers", "Tailwind CSS", "JavaScript"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://tboyemedia.com/",
    featured: true,
    status: "completed",
    completedDate: "2026-01-01",
    duration: "1 month",
    teamSize: "1",
    priority: -1,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Digital Media", "Brand Strategy", "Content Creation", "Media Platform"],
    challenges: [
      "Building a cohesive platform for diverse media services.",
      "Creating an engaging and professional brand presence.",
      "Ensuring fast load times for media-heavy content.",
    ],
    solutions: [
      "Hosted frontend on Netlify for fast global delivery.",
      "Used Cloudflare Workers for serverless backend API.",
      "Built a clean, brand-forward UI with strong visual hierarchy.",
    ],
  },
  {
    id: 26,
    title: "SmartTech AI",
    description:
      "An AI-powered technology platform offering intelligent tools and solutions for businesses and individuals.",
    longDescription: `
      SmartTech AI is an AI-powered technology platform designed to provide smart, practical solutions for businesses and individuals. It brings cutting-edge AI capabilities into an accessible, user-friendly interface.

      Key features:
      • AI-powered tools and automation
      • Business intelligence and analytics
      • Intelligent workflow solutions
      • User dashboard with personalized insights
      • Service listings and AI product offerings
      • Secure user authentication
      • Responsive, modern design
      • Fast serverless backend
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://www.smarttechai1.com/",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://www.smarttechai1.com/"],
    technologies: ["Cloudflare Pages", "Cloudflare Workers", "Cloudflare D1", "AI/ML", "JavaScript"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://www.smarttechai1.com/",
    featured: true,
    status: "completed",
    completedDate: "2026-01-01",
    duration: "1 month",
    teamSize: "1",
    priority: 0,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Full Cloudflare Stack", "AI-Powered", "Edge Computing", "Smart Automation"],
    challenges: [
      "Building a fully serverless AI platform on Cloudflare's edge network.",
      "Managing AI workloads within Cloudflare Worker constraints.",
      "Making complex AI tools accessible to non-technical users.",
    ],
    solutions: [
      "Deployed frontend on Cloudflare Pages for global edge delivery.",
      "Used Cloudflare Workers for all backend API and AI integrations.",
      "Leveraged Cloudflare D1 for serverless edge database storage.",
    ],
  },
  {
    id: 22,
    title: "Klaroafrica",
    description:
      "An AI-powered document intelligence platform that converts complex legal language into plain English, highlights risks, and explains what you're agreeing to.",
    longDescription: `
      Klaroafrica is an AI-powered document intelligence platform built for musicians, creatives, and anyone who regularly deals with legal documents. Users upload contracts, agreements, or any legal paperwork — and the system instantly breaks it down into plain, understandable English.

      Key features:
      • Upload contracts, NDAs, licensing agreements, and more
      • AI translates dense legal language into clear, plain English
      • Risk detection — highlights clauses that could harm you
      • Explains what you're actually agreeing to, section by section
      • Tailored for musicians, creators, and independent professionals
      • Identifies unfair terms, hidden obligations, and red flags
      • Fast, clean interface with instant results
      • Secure document handling
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://klaro-africa.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://klaro-africa.netlify.app/"],
    technologies: ["React", "AI/NLP", "Node.js", "Netlify", "Tailwind CSS"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://klaro-africa.netlify.app",
    featured: true,
    status: "completed",
    completedDate: "2026-01-01",
    duration: "1 month",
    teamSize: "1",
    priority: -2,
    year: "2026",
    seekingInvestment: true,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["AI Legal Translation", "Risk Detection", "Plain English", "Built for Creatives"],
    challenges: [
      "Accurately translating complex legal jargon into plain language.",
      "Detecting and flagging risky clauses without missing context.",
      "Making the output accessible to non-lawyers.",
    ],
    solutions: [
      "Used AI/NLP models to parse and rewrite legal text in plain English.",
      "Built a risk-scoring engine to flag potentially harmful clauses.",
      "Designed a clean, section-by-section breakdown UI for clarity.",
    ],
  },
  {
    id: 28,
    title: "The PD Collective",
    description:
      "A premium fashion e-commerce platform for fashion, bags and wigs in Ghana. Features MoMo checkout, AI Style Advisor, rider partnership programme, and nationwide delivery.",
    longDescription: `
      The PD Collective is a full-featured fashion e-commerce platform built for a Ghana-based retailer selling premium clothing, bags, and wigs. Built entirely on Cloudflare infrastructure with Nuxt.js on the frontend and Cloudflare Workers powering the backend API.

      Key features:
      • Full product catalogue with filtering by category, price, and popularity
      • Mobile Money (MoMo) secure checkout
      • AI Style Advisor for personalised fashion recommendations
      • Rider sign-up and partner programme for last-mile delivery
      • Real-time order tracking
      • Wishlist, coupons, and PD Club loyalty programme
      • Progressive Web App (PWA) — installable on any device
      • Newsletter subscription and customer review system
      • Fast nationwide delivery across Ghana
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/noanimate/https://thepdcollective.pages.dev/",
    images: ["https://image.thum.io/get/width/1200/crop/630/noanimate/https://thepdcollective.pages.dev/"],
    technologies: ["Nuxt.js", "Cloudflare Pages", "Cloudflare Workers", "Cloudflare D1", "JavaScript"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://thepdcollective.pages.dev/",
    featured: true,
    status: "completed",
    completedDate: "2026-01-01",
    duration: "2 months",
    teamSize: "1",
    priority: 0,
    year: "2026",
    seekingInvestment: false,
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Fashion E-Commerce", "MoMo Checkout", "AI Style Advisor", "PWA", "Rider Programme"],
    challenges: [
      "Building a full e-commerce flow including cart, checkout, and order tracking on Cloudflare's edge.",
      "Integrating Mobile Money payment processing for Ghana.",
      "Designing a rider partnership and delivery management system.",
    ],
    solutions: [
      "Used Cloudflare Workers for serverless backend API with D1 as the database.",
      "Built a clean, mobile-first PWA with Nuxt.js for fast load times.",
      "Implemented the full rider sign-up and fulfilment workflow from scratch.",
    ],
  },
  {
    id: 0,
    title: "SMSGate",
    description:
      "A multi-tenant SMS gateway platform built with Vercel Functions, enabling businesses to send and manage SMS messages through a shared, scalable infrastructure.",
    longDescription: `
      SMSGate is a production-ready, multi-tenant SMS gateway built entirely on serverless Vercel Functions. It lets multiple businesses and clients send, receive, and manage SMS messages through a single scalable infrastructure — each tenant isolated with their own credentials, usage limits, and message history.

      Key features:
      • Multi-tenant architecture — each client gets isolated credentials and data
      • Serverless backend powered by Vercel Functions (zero server management)
      • Send and receive SMS messages via integrated provider APIs
      • Per-tenant usage tracking and rate limiting
      • Webhook support for incoming message delivery
      • API key management per tenant
      • Clean dashboard for monitoring message delivery
      • Lightweight and fast — cold-starts under 300ms
    `,
    image: "/images/web apps/smsgate.png",
    images: ["/images/web apps/smsgate.png"],
    technologies: ["Vercel Functions", "Node.js", "JavaScript", "SMS API", "Multi-Tenant"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://sms-gate-app.vercel.app",
    featured: true,
    status: "completed",
    completedDate: "2026-01-01",
    duration: "1 month",
    teamSize: "1",
    priority: 0,
    year: "2026",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Multi-Tenant Architecture",
      "Vercel Functions",
      "SMS Gateway",
      "Serverless",
    ],
    challenges: [
      "Designing tenant isolation in a shared serverless environment.",
      "Handling webhook delivery reliably without a persistent server.",
      "Managing per-tenant rate limiting at the edge.",
    ],
    solutions: [
      "Used separate API key scoping and DB namespacing per tenant.",
      "Implemented idempotent webhook handlers with retry logic.",
      "Built rate limiting middleware in Vercel Edge Functions.",
    ],
  },
  {
    id: 1,
    title: "MySMSVerify",
    description:
      "A virtual phone number rental platform that lets users receive SMS verification codes from 250+ apps across 68 countries, without using their personal number.",
    longDescription: `
      MySMSVerify is a full-stack virtual phone number service built with React and Netlify Functions. It enables users to rent temporary phone numbers from 68 countries to receive OTP and SMS verification codes for over 250 apps and websites — protecting their personal privacy.

      Key features:
      • Virtual number rental from 68 countries worldwide
      • Support for 250+ apps and services (WhatsApp, Telegram, Google, and more)
      • Real-time SMS delivery and OTP display
      • Affordable per-use pricing model
      • User dashboard with rental history
      • Secure payment processing
      • Serverless backend with Netlify Functions
      • Responsive design for all devices
    `,
    image: "/images/web apps/mysmsverify.jpeg",
    images: ["/images/web apps/mysmsverify.jpeg"],
    technologies: ["React", "Netlify Functions", "Node.js", "Tailwind CSS", "JavaScript"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://www.mysmsverify.com/",
    featured: true,
    status: "completed",
    completedDate: "2026-02-01",
    duration: "1 month",
    teamSize: "1",
    priority: 1,
    year: "2026",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Virtual Number Rental",
      "68 Countries",
      "250+ Supported Apps",
      "Serverless Backend",
    ],
    challenges: [
      "Integrating real-time SMS delivery and number provisioning.",
      "Managing number availability across multiple countries.",
      "Building a reliable per-use billing and payment system.",
    ],
    solutions: [
      "Used Netlify Functions for serverless API and third-party SMS integrations.",
      "Implemented real-time polling for incoming SMS messages.",
      "Built a flexible pricing engine with secure payment flow.",
    ],
  },
  {
    id: 23,
    title: "1Papi Data Hub",
    description:
      "A full-stack platform for buying and reselling mobile data bundles, built with Vercel Functions for a fast, scalable serverless experience.",
    longDescription: `
      1Papi Data Hub is a full-stack data reselling platform that enables users to purchase mobile data bundles and become resellers. Built with React and Vercel Functions, it delivers a seamless and scalable experience for both end users and resellers.

      Key features:
      • Browse and purchase mobile data bundles
      • Reseller registration and management
      • User dashboard with transaction history
      • Secure payment processing
      • Reseller pricing and profit tracking
      • Order management and fulfillment
      • Responsive design for all devices
      • Real-time order status updates
      • Serverless backend powered by Vercel Functions
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://www.1papi.com/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://www.1papi.com/"],
    technologies: [
      "React",
      "Vercel Functions",
      "Node.js",
      "Tailwind CSS",
      "JavaScript",
    ],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://www.1papi.com",
    featured: true,
    status: "completed",
    completedDate: "2026-02-13",
    duration: "2 months",
    teamSize: "1",
    priority: 2,
    year: "2026",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Data Reselling Platform",
      "Vercel Functions",
      "Reseller Management",
      "Payment Integration",
    ],
    challenges: [
      "Building a reliable data purchasing and fulfillment system.",
      "Implementing reseller tier pricing and profit calculations.",
      "Handling secure payment processing for data bundles.",
    ],
    solutions: [
      "Used Vercel Functions for serverless API endpoints.",
      "Created flexible pricing engine for reseller tiers.",
      "Implemented secure payment flow with transaction validation.",
    ],
  },
  {
    id: 2,
    title: "Smart Data Hub",
    description:
      "A full-stack platform for buying and reselling mobile data bundles with user-friendly dashboard and reseller management.",
    longDescription: `
      Smart Data Hub is a full-stack data reselling platform that enables users to purchase mobile data bundles and also become resellers. Built with React and Netlify Functions, it provides a seamless experience for both end users and resellers.

      Key features:
      • Browse and purchase mobile data bundles
      • Reseller registration and management
      • User dashboard with transaction history
      • Secure payment processing
      • Reseller pricing and profit tracking
      • Order management and fulfillment
      • Responsive design for all devices
      • Real-time order status updates
    `,
    image: "/images/web apps/smartdatahub.png",
    images: ["/images/web apps/smartdatahub.png"],
    technologies: [
      "React",
      "Netlify Functions",
      "Node.js",
      "Tailwind CSS",
      "JavaScript",
    ],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://smartdatafy.com",
    featured: true,
    status: "completed",
    completedDate: "2026-02-13",
    duration: "2 months",
    teamSize: "1",
    priority: 2,
    year: "2026",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Data Reselling Platform",
      "Serverless Backend",
      "Reseller Management",
      "Payment Integration",
    ],
    challenges: [
      "Building a reliable data purchasing and fulfillment system.",
      "Implementing reseller tier pricing and profit calculations.",
      "Handling secure payment processing for data bundles.",
    ],
    solutions: [
      "Used Netlify Functions for serverless API endpoints.",
      "Created flexible pricing engine for reseller tiers.",
      "Implemented secure payment flow with transaction validation.",
    ],
  },
  {
    id: 3,
    title: "MedHeal HMS",
    description:
      "A comprehensive Hospital Management System for streamlining healthcare facility operations, patient records, and administrative workflows.",
    longDescription: `
      MedHeal HMS is a full-stack Hospital Management System designed to digitize and streamline healthcare facility operations. It provides tools for managing patient records, appointments, staff, and administrative tasks in a unified platform.

      Key features:
      • Patient registration and records management
      • Appointment scheduling and tracking
      • Staff and department management
      • Medical history and diagnosis records
      • Dashboard with key healthcare metrics
      • Role-based access control
      • Responsive design for all devices
      • Secure data handling
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://mediheal-hms.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://mediheal-hms.netlify.app/"],
    technologies: ["React", "JavaScript", "PostgreSQL", "Node.js", "Tailwind CSS"],
    category: "healthcare",
    githubUrl: null,
    liveUrl: "https://mediheal-hms.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2026-02-15",
    duration: "2 months",
    teamSize: "1",
    priority: 3,
    year: "2026",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Hospital Management",
      "Patient Records",
      "Role-Based Access",
      "Healthcare Dashboard",
    ],
    challenges: [
      "Designing a complex relational database for healthcare data.",
      "Implementing role-based access for different staff levels.",
      "Ensuring secure handling of sensitive patient information.",
    ],
    solutions: [
      "Used PostgreSQL with normalized schema for healthcare data.",
      "Implemented JWT-based authentication with role permissions.",
      "Applied encryption and security best practices for patient data.",
    ],
  },
  // ── 2025 ──────────────────────────────────────────────────────────────────
  {
    id: 4,
    title: "PageLock",
    description:
      "A powerful website cloning tool that allows you to download and save any website for offline viewing.",
    longDescription: `
      PageLock is a powerful website cloning tool that allows you to download and save any website for offline viewing. Clone single pages or entire websites with all their assets. The backend, running on Netlify Functions, utilizes cloudscraper to bypass Cloudflare and Cheerio for deep HTML parsing.

      Core Features:
      • Clone single pages or entire websites
      • Download all assets (images, CSS, JavaScript)
      • Cloudflare bypass capability
      • Configurable crawl depth
      • ZIP archive export for full websites
      • Offline viewing capability
      • Dark theme UI
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://pagelock.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://pagelock.netlify.app/"],
    technologies: [
      "React 18",
      "Netlify Functions",
      "Node.js",
      "Cloudscraper",
      "Cheerio",
      "Tailwind CSS",
    ],
    category: "fullstack",
    githubUrl: "https://github.com/t-boye/PageLock",
    liveUrl: "https://pagelock.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2025-02-10",
    duration: "2 months",
    teamSize: "1",
    priority: 4,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: ["Website Cloning", "Cloudflare Bypass", "Offline Ready"],
    challenges: [
      "Bypassing Cloudflare protection.",
      "Downloading all assets correctly.",
      "Maintaining page functionality offline.",
    ],
    solutions: [
      "Implemented cloudscraper for Cloudflare bypass.",
      "Used Cheerio for reliable HTML parsing.",
      "Created asset bundling system.",
    ],
  },
  {
    id: 5,
    title: "ANU-BookMyDorm",
    description:
      "A comprehensive full-stack system designed to facilitate the booking, management, and allocation of dormitory accommodations.",
    longDescription: `
      ANU-BookMyDorm is built as a complete solution for student housing management. It offers a seamless user interface for students to browse available rooms, view details, and complete the booking process. The system includes an administrative dashboard that provides features for room allocation, tenant management, payment tracking, and generating reports.

      Key features:
      • Room booking and reservation system
      • Admin dashboard for housing management
      • Payment tracking and processing
      • Tenant records management
      • Real-time availability updates
      • Report generation
    `,
    image: "https://i.postimg.cc/52bKT7KQ/anu-bookmydorm.jpg",
    images: ["https://i.postimg.cc/52bKT7KQ/anu-bookmydorm.jpg"],
    technologies: [
      "React",
      "Node.js",
      "Postgres",
      "Express.js",
      "Tailwind CSS",
      "JavaScript",
    ],
    category: "fullstack",
    githubUrl: "https://github.com/t-boye/ANU-BookMyDorm-System",
    liveUrl: "https://anu-bookmyroom.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2025-02-01",
    duration: "4 months",
    teamSize: "1",
    priority: 5,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Personal Project",
      "Responsive Design",
      "Database Management",
    ],
    challenges: [
      "Designing a complex database schema for housing management.",
      "Implementing real-time availability updates.",
      "Creating an intuitive admin dashboard.",
    ],
    solutions: [
      "Used PostgreSQL for robust data management.",
      "Implemented WebSocket for real-time updates.",
      "Designed user-friendly admin interface with React.",
    ],
  },
  {
    id: 6,
    title: "SwiftScan POS",
    description:
      "A modern, responsive Point of Sale (POS) application that enables quick and accurate transaction processing.",
    longDescription: `
      SwiftScan-POS is a full-featured retail management system. The frontend provides a sleek, touch-friendly interface for sales staff to rapidly add items, apply discounts, and process various payment types. The backend handles real-time inventory updates, data storage for sales reports, and user authentication.

      Key features:
      • Quick transaction processing
      • Product and inventory management
      • Multiple payment methods support
      • Real-time sales reporting
      • User authentication and roles
      • Touch-friendly interface
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://swift-pos.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://swift-pos.netlify.app/"],
    technologies: ["React", "Postgres", "Tailwind CSS", "Python"],
    category: "fullstack",
    githubUrl: "https://github.com/t-boye/SwiftScan-POS",
    liveUrl: "https://swift-pos.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2025-02-10",
    duration: "3 months",
    teamSize: "1",
    priority: 6,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Client Project",
      "Real-time Processing",
      "Inventory Management",
    ],
    challenges: [
      "Ensuring fast transaction processing.",
      "Handling concurrent transactions safely.",
      "Creating an intuitive touch interface.",
    ],
    solutions: [
      "Optimized database queries for speed.",
      "Implemented transaction locking mechanisms.",
      "Designed large touch-friendly UI elements.",
    ],
  },
  {
    id: 7,
    title: "DevTools: Free Developer Utilities",
    description:
      "A comprehensive suite of 19 free developer tools with a modern dark theme and red accents, built with React and Tailwind CSS.",
    longDescription: `
      DevTools is a comprehensive suite of 19 free developer tools featuring a modern dark theme with red accents. Built with React and Tailwind CSS, it's designed for maximum developer productivity with all tools running 100% client-side for complete privacy.

      Key features:
      • 19 developer utilities in one place
      • Modern dark theme with red accents
      • 100% client-side processing (zero data transmission)
      • JWT decoder, password generator, formatters, converters
      • Regex tester and diff checker
      • Favorites system with keyboard shortcuts (Ctrl+K search)
      • PWA installation support
      • Dark/Light mode toggle
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://devtools001.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://devtools001.netlify.app/"],
    technologies: ["React 19", "Vite 7", "Tailwind CSS v4", "jose"],
    category: "frontend",
    githubUrl: "https://github.com/t-boye/DevTools",
    liveUrl: "https://devtools001.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2025-01-15",
    duration: "2 months",
    teamSize: "1",
    priority: 7,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "19 Free Developer Tools",
      "100% Client-Side Privacy",
      "Modern Dark Theme with Red Accents",
      "Productivity-First UX",
    ],
    challenges: [
      "Ensuring all processing happens client-side.",
      "Integrating 19 different utilities seamlessly.",
      "Maintaining high performance across all tools.",
    ],
    solutions: [
      "Used Web Workers for heavy computations.",
      "Created modular architecture for utilities.",
      "Implemented code splitting for better performance.",
    ],
  },
  {
    id: 8,
    title: "Medicinal Plant Identifier (AI)",
    description:
      "A fullstack web application that accurately identifies medicinal plant species from user-uploaded images.",
    longDescription: `
      This is a full-stack, deep learning solution for botanical identification. The Python backend processes the image using a trained Convolutional Neural Network (CNN) model to achieve high-accuracy classification. The React frontend offers a fast, user-friendly interface for image uploads and displays identification results.

      Key features:
      • AI-powered plant identification
      • Image upload and processing
      • Scientific name and properties display
      • User-friendly interface
      • Real-time classification
      • Plant database integration
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://medifind-dfk.pages.dev/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://medifind-dfk.pages.dev/"],
    technologies: [
      "Python",
      "Flask",
      "TensorFlow",
      "scikit-learn",
      "OpenCV",
      "React",
      "Axios",
      "Tailwind CSS",
    ],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://medifind-dfk.pages.dev/",
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "4 months",
    teamSize: "1",
    priority: 8,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Deep Learning (CNN) Model",
      "Image Recognition",
      "Python Backend API",
      "Real-Time Classification",
    ],
    challenges: [
      "Training accurate plant identification model.",
      "Handling large image uploads efficiently.",
      "Providing detailed plant information.",
    ],
    solutions: [
      "Used transfer learning with pre-trained CNN models.",
      "Implemented image compression and optimization.",
      "Integrated comprehensive plant database.",
    ],
  },
  {
    id: 9,
    title: "ExamsVault",
    description:
      "A comprehensive exam preparation platform with 600+ questions, mock exams, certificates, and a referral system.",
    longDescription: `
      ExamsVault is a full-featured exam preparation and learning platform that helps students prepare for exams with extensive question banks, timed mock exams, and performance analytics. Earn certificates for high scores and get rewarded through the referral system.

      Core Features:

      Exam Preparation
      • Extensive Question Bank - 600+ questions across multiple subjects and exam types
      • Mock Exams - Timed practice exams with realistic conditions (Easy, Medium, Hard)
      • Auto-Grading System - Instant results with detailed performance analysis
      • Subject-wise Analytics - Track performance by subject and difficulty level

      Certificates & Achievements
      • Auto-Generated Certificates - Earn certificates for scoring 70%+ on medium/hard exams
      • Professional Design - Traditional certificate layout with official seal and signature
      • PDF Download - Download certificates as high-quality PDFs
      • Certificate Verification - Unique certificate IDs for verification

      User Management
      • User Authentication - Secure registration and login with JWT
      • Profile Management - Update personal information, phone, and school details
      • Password Security - Secure password change functionality
      • Notification Preferences - Customize email, exam reminders, and weekly reports

      Referral System
      • Earn While Learning - Get $0.05 for every successful referral
      • Unique Referral Codes - Each user gets a personalized referral code
      • Referral Tracking - Track your referrals and earnings in real-time
      • Automatic Payouts - Earnings tracked in your account

      Progress Tracking
      • Comprehensive Analytics - Track overall progress and performance trends
      • Subject Breakdown - Detailed performance metrics by subject
      • Exam History - Review past attempts and scores
      • Improvement Recommendations - Get personalized study suggestions

      School Tracking
      • School Affiliation - Optional school name field for students
      • School-based Analytics - Track performance by school (admin feature)
      • Leaderboards - Compare performance within schools (coming soon)

      Modern UI/UX
      • Responsive Design - Works seamlessly on mobile, tablet, and desktop
      • Animated Navigation - Smooth hover effects and active state highlighting
      • Dark Mode Ready - Professional gradient color scheme (#11224E)
      • Accessibility - WCAG compliant design
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://examsvault.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://examsvault.netlify.app/"],
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "Express.js",
      "JWT",
      "PDF Generation",
    ],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://app.netlify.com/projects/examsvault",
    featured: true,
    status: "maintenance",
    completedDate: "2025-02-15",
    duration: "5 months",
    teamSize: "1",
    priority: 9,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "600+ Questions",
      "Certificate System",
      "Referral Program",
      "Performance Analytics",
    ],
    challenges: [
      "Managing large question bank efficiently.",
      "Generating professional PDF certificates.",
      "Implementing fair referral tracking system.",
    ],
    solutions: [
      "Optimized database queries with indexing.",
      "Used PDF generation libraries for certificates.",
      "Created secure referral code system with validation.",
    ],
  },
  {
    id: 10,
    title: "XtraSpot",
    description:
      "An alternative platform for content creators with premium content features and cryptocurrency payment support.",
    longDescription: `
      XtraSpot is a modern content creator platform that provides an alternative to traditional subscription-based platforms. It features premium content management, secure payments including cryptocurrency, and powerful creator tools.

      Core Features:

      Content Management
      • Upload and manage premium content
      • Photo and video support
      • Content scheduling and organization
      • Privacy controls and access management

      Multiple Payment Options
      • Traditional payment methods
      • Cryptocurrency payment support
      • Subscription tiers
      • Pay-per-view content options

      Creator Tools
      • Analytics dashboard
      • Subscriber management
      • Revenue tracking
      • Content performance metrics

      Security & Privacy
      • Secure authentication
      • Content protection
      • Privacy-focused design
      • DMCA compliance tools

      Modern UI/UX
      • Responsive design
      • Mobile-friendly interface
      • Dark/Light mode
      • Smooth animations
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://xtraspot.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://xtraspot.netlify.app/"],
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "Express.js",
      "Stripe",
      "Web3.js",
    ],
    category: "fullstack",
    githubUrl: null,
    liveUrl: null,
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "4 months",
    teamSize: "1",
    priority: 10,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Premium Content Platform",
      "Crypto Payments",
      "Creator Analytics",
      "Multi-tier Subscriptions",
    ],
    challenges: [
      "Implementing secure content protection.",
      "Integrating cryptocurrency payments.",
      "Building scalable creator dashboard.",
    ],
    solutions: [
      "Implemented content encryption and watermarking.",
      "Used Web3.js for crypto payment integration.",
      "Created modular analytics system.",
    ],
  },
  {
    id: 12,
    title: "My Own",
    description:
      "A modern mobile dating application designed to help users find meaningful connections.",
    longDescription: `
      My Own is a mobile dating application built with React Native, focusing on creating genuine connections between users through a modern and intuitive interface.

      Key features:
      • Smart matching algorithm
      • User profile customization
      • Real-time chat functionality
      • Location-based discovery
      • Privacy controls
      • Photo verification
      • Modern and sleek UI design
      • Push notifications
    `,
    image: "/images/mobile-apps/myown.png",
    images: ["/images/mobile-apps/myown.png"],
    technologies: ["React Native", "Python", "PostgreSQL", "Expo"],
    category: "mobile",
    githubUrl: null,
    liveUrl: null,
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "4 months",
    teamSize: "1",
    priority: 12,
    year: "2025",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Smart Matching",
      "Real-time Chat",
      "React Native",
      "Location-Based",
    ],
    challenges: [
      "Building an effective matching algorithm.",
      "Implementing real-time chat at scale.",
      "Ensuring user privacy and safety.",
    ],
    solutions: [
      "Developed custom matching logic based on preferences.",
      "Used WebSockets for instant messaging.",
      "Implemented verification and reporting systems.",
    ],
  },
  // ── 2024 ──────────────────────────────────────────────────────────────────
  {
    id: 13,
    title: "Football League Web App",
    description:
      "A comprehensive sports management platform for football league operations.",
    longDescription: `
      A comprehensive sports management platform designed for football league operations, featuring team standings, match scheduling, player statistics, and real-time score updates with modern web technologies.

      Key features:
      • Real-time league standings and updates
      • Match scheduling and results tracking
      • Player and team profiles with statistics
      • Admin panel for league management
      • Responsive design for all devices
      • API integration for live data
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://anu-football-league-table.vercel.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://anu-football-league-table.vercel.app/"],
    technologies: ["React", "Node.js", "MongoDB", "Express.js", "Tailwind CSS"],
    category: "fullstack",
    githubUrl: "https://github.com/t-boye/school-football-league",
    liveUrl: "https://anu-football-league-table.vercel.app/",
    featured: true,
    status: "completed",
    completedDate: "2024-07-28",
    duration: "2 months",
    teamSize: "1",
    priority: 13,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: ["Real-time Updates", "API Integration", "Data Visualization"],
    challenges: [
      "Handling real-time score updates and data synchronization.",
      "Designing a user-friendly and intuitive admin dashboard.",
      "Ensuring the website could handle a large number of concurrent users during games.",
    ],
    solutions: [
      "Used WebSockets for instant score updates.",
      "Created a simplified admin interface with drag-and-drop functionality.",
      "Optimized database queries and implemented caching strategies.",
    ],
  },
  {
    id: 14,
    title: "Multi-Disease Diagnosis System",
    description:
      "An intelligent healthcare application utilizing artificial intelligence for preliminary diagnostic suggestions.",
    longDescription: `
      An intelligent healthcare application utilizing artificial intelligence to analyze symptoms and provide preliminary diagnostic suggestions for multiple medical conditions, supporting early detection efforts.

      Key features:
      • Machine learning-based diagnosis
      • Symptom input and analysis
      • User-friendly interface
      • Data-driven health insights
      • Cross-platform compatibility
      • Privacy-focused design
    `,
    image: "https://i.postimg.cc/FKvcDGwX/clarity-DX-homepage.png",
    images: ["https://i.postimg.cc/FKvcDGwX/clarity-DX-homepage.png"],
    technologies: [
      "Python",
      "Scikit-learn",
      "TensorFlow",
      "AI algorithms",
      "Flask/FastAPI",
      "React",
    ],
    category: "healthcare",
    githubUrl: "https://github.com/t-boye/disease-diagnosis-system",
    liveUrl: "https://claritydx.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2024-05-20",
    duration: "4 months",
    teamSize: "1",
    priority: 14,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Machine Learning",
      "Healthcare Analytics",
      "Predictive Modeling",
    ],
    challenges: [
      "Acquiring and preprocessing a clean and diverse dataset.",
      "Ensuring the model's accuracy and reliability.",
      "Creating a user-friendly and intuitive interface for a complex system.",
    ],
    solutions: [
      "Used public health datasets and data cleaning techniques.",
      "Implemented a multi-model approach for improved accuracy.",
      "Designed a simple, step-by-step user flow for symptom input.",
    ],
  },
  {
    id: 16,
    title: "My Portfolio Website",
    description: "A personal showcase platform with interactive 3D elements.",
    longDescription: `
      A personal showcase platform highlighting professional skills and projects through interactive 3D elements, smooth animations, and engaging visual presentations to demonstrate web development expertise.

      Key features:
      • Interactive 3D elements with Three.js
      • Smooth animations using Framer Motion
      • Responsive design for all devices
      • Dark/Light mode toggle
      • Project showcase with filters
      • Contact form integration
    `,
    image: "https://i.postimg.cc/Zq788VDd/port.png",
    images: ["https://i.postimg.cc/Zq788VDd/port.png"],
    technologies: [
      "React",
      "Three.js",
      "Framer Motion",
      "Tailwind CSS",
      "Vite",
    ],
    category: "frontend",
    githubUrl: null,
    liveUrl: "https://tboyetech-portfolio.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2024-08-15",
    duration: "2 months",
    teamSize: "1",
    priority: 16,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "3D Animations",
      "Interactive Design",
      "Performance Optimized",
      "UI/UX",
    ],
    challenges: [
      "Optimizing 3D performance for lower-end devices.",
      "Creating smooth animations without impacting page load.",
      "Ensuring cross-browser compatibility.",
    ],
    solutions: [
      "Implemented lazy loading for 3D assets.",
      "Used requestAnimationFrame for smooth animations.",
      "Tested extensively across different browsers and devices.",
    ],
  },
  {
    id: 17,
    title: "Air Pollution System",
    description:
      "An environmental monitoring application for real-time air quality data.",
    longDescription: `
      An environmental monitoring application that tracks and visualizes air quality data in real-time, providing pollution level alerts, trend analysis, and location-based environmental health information.

      Key features:
      • Real-time air quality monitoring
      • Interactive data visualizations
      • Location-based pollution alerts
      • Historical trend analysis
      • API integration for multiple data sources
      • Responsive design
    `,
    image: "https://i.postimg.cc/xTdV1CVT/air-quality.png",
    images: ["https://i.postimg.cc/xTdV1CVT/air-quality.png"],
    technologies: ["React", "Python", "D3.js", "Chart.js", "API Integration"],
    category: "fullstack",
    githubUrl: "https://github.com/t-boye/air-pollution-system",
    liveUrl: "https://air-pollution-monitoring-system-one.vercel.app",
    featured: false,
    status: "completed",
    completedDate: "2024-12-01",
    duration: "2 months",
    teamSize: "1",
    priority: 17,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Real-time Data",
      "Data Visualization",
      "Environmental Monitoring",
    ],
    challenges: [
      "Integrating multiple air quality data APIs.",
      "Creating meaningful data visualizations.",
      "Handling real-time data updates efficiently.",
    ],
    solutions: [
      "Unified data format for multiple API sources.",
      "Used D3.js for interactive visualizations.",
      "Implemented WebSocket connections for real-time updates.",
    ],
  },
  {
    id: 18,
    title: "Liamma Care",
    description:
      "A professional service website for an Australian home care provider.",
    longDescription: `
      A professional service website for an Australian home care provider, featuring comprehensive service information, client resources, and easy contact methods for aged care, disability support, and veteran services.

      Key features:
      • Service information pages
      • Client testimonials
      • Contact forms
      • Responsive design
      • SEO optimized
      • Accessibility compliant
    `,
    image: "https://i.postimg.cc/P59jckcf/liamma-care.png",
    images: ["https://i.postimg.cc/P59jckcf/liamma-care.png"],
    technologies: ["HTML", "CSS", "JavaScript", "Responsive Design", "UI/UX"],
    category: "frontend",
    githubUrl: null,
    liveUrl: "https://iamma-care.netlify.app/",
    featured: true,
    status: "completed",
    completedDate: "2024-06-15",
    duration: "3 months",
    teamSize: "1",
    priority: 18,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: ["Client Project", "Responsive Design", "SEO Optimization"],
    challenges: [
      "Ensuring full compliance with complex accessibility standards.",
      "Integrating accessibility features without compromising on design.",
      "Conducting extensive testing with accessibility tools and real users.",
    ],
    solutions: [
      "Followed WCAG 2.1 guidelines from the start of the project.",
      "Used ARIA attributes and semantic HTML to enhance screen reader support.",
      "Conducted automated and manual accessibility audits.",
    ],
  },
  {
    id: 19,
    title: "Gateway Programming Language",
    description:
      "The easiest programming language to learn. Perfect for complete beginners, students, and rapid prototyping.",
    longDescription: `
      Gateway is a beginner-friendly programming language designed to make learning to code as simple as possible. With natural English-like syntax and friendly error messages, it's perfect for students and newcomers to programming.

      Why Gateway?
      Gateway makes programming simple and intuitive with:

      Key Features:
      • Natural English-like syntax - Write code that reads like English
      • No indentation errors - Uses end keyword instead of indentation
      • Friendly error messages - Clear explanations with line highlighting
      • Interactive REPL - Try code instantly with auto-complete
      • 60+ built-in functions - Everything beginners need (file I/O, strings, user input)
      • Optional typing - Add types when you want, skip them when you don't

      Perfect for Learning:
      • Complete beginners with no programming experience
      • Students learning their first programming language
      • Rapid prototyping and quick scripts
      • Teaching programming concepts without syntax complexity

      Getting Started:
      • Easy installation with Python 3.7+
      • Interactive REPL for instant feedback
      • Comprehensive documentation
      • Example programs included

      Code Examples:
      Variables, loops, and conditionals use simple English words that make sense to non-programmers. No confusing symbols or cryptic syntax to memorize.
    `,
    image: "https://image.thum.io/get/width/1200/crop/630/https://gateway-lang.netlify.app/",
    images: ["https://image.thum.io/get/width/1200/crop/630/https://gateway-lang.netlify.app/"],
    technologies: ["Python", "Compiler Design", "Language Design", "REPL"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: null,
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "6 months",
    teamSize: "1",
    priority: 19,
    year: "2024",
    stats: {
      stars: 0,
      forks: 0,
      commits: 0,
      watchers: 0,
    },
    highlights: [
      "Natural Syntax",
      "Beginner-Friendly",
      "Interactive REPL",
      "60+ Built-in Functions",
    ],
    challenges: [
      "Designing intuitive syntax for beginners.",
      "Providing helpful error messages.",
      "Creating interactive REPL with auto-complete.",
    ],
    solutions: [
      "Used Python as implementation language for simplicity.",
      "Designed English-like keywords and syntax.",
      "Implemented custom error handling with explanations.",
    ],
  },
  {
    id: 24,
    title: "Abeka Royal Archive",
    description:
      "A digital heritage archive preserving the history, chiefs, and culture of the Abeka chieftaincy in Accra, Ghana.",
    longDescription: `
      Abeka Royal Archive is a digital heritage platform built to preserve and celebrate the rich history of the Abeka chieftaincy in Accra, Ghana. The platform serves as an official digital record for the community — documenting chiefs, royal lineages, historical events, and cultural heritage.

      Key features:
      • Digital archive of chiefs and royal lineage
      • Historical records and cultural documentation
      • Photo gallery of chieftaincy events and ceremonies
      • Cloudflare D1 database for fast, serverless data storage
      • Cloudflare Workers for edge-deployed API performance
      • Fully SSR-rendered with Nuxt.js for speed and SEO
      • Tailored for community access and heritage education
      • Mobile-first responsive design
    `,
    image: "/images/web apps/abekaarchive.jpeg",
    images: ["/images/web apps/abekaarchive.jpeg"],
    technologies: ["Nuxt.js", "TypeScript", "Cloudflare Workers", "Cloudflare D1", "Tailwind CSS"],
    category: "fullstack",
    githubUrl: null,
    liveUrl: "https://abekaarchive.pages.dev/",
    featured: true,
    status: "in-progress",
    completedDate: null,
    duration: "Active development",
    teamSize: "1",
    priority: 0,
    year: "2026",
    stats: { stars: 0, forks: 0, commits: 0, watchers: 0 },
    highlights: ["Digital Heritage", "Cloudflare Edge", "Nuxt.js SSR", "Chieftaincy Archive"],
    challenges: [
      "Digitizing and structuring historical records from physical documents.",
      "Building a platform accessible to community members with varying digital literacy.",
      "Ensuring the platform loads fast for users across Ghana.",
    ],
    solutions: [
      "Used Cloudflare D1 and Workers for edge-deployed, serverless infrastructure.",
      "Built with Nuxt.js for full SSR and fast page loads.",
      "Designed a clean, intuitive interface for all ages.",
    ],
  },
  // ── 2023 ──────────────────────────────────────────────────────────────────
];
